export var TimeTableRowSize;
(function (TimeTableRowSize) {
    TimeTableRowSize["SMALL"] = "small";
    TimeTableRowSize["MEDIUM"] = "medium";
    TimeTableRowSize["LARGE"] = "large";
})(TimeTableRowSize || (TimeTableRowSize = {}));
export var TimetableControlTypes;
(function (TimetableControlTypes) {
    TimetableControlTypes["SCHEDULER"] = "SCHEDULER";
    TimetableControlTypes["TEMPERATURE"] = "TEMPERATURE";
    TimetableControlTypes["VENSTAR_HVAC"] = "VENSTAR_HVAC";
    TimetableControlTypes["LIGHT_SENSOR"] = "LIGHT_SENSOR";
})(TimetableControlTypes || (TimetableControlTypes = {}));
export var TimetableOverrideType;
(function (TimetableOverrideType) {
    TimetableOverrideType["ALWAYS_ON"] = "ALWAYS_ON";
    TimetableOverrideType["ALWAYS_OFF"] = "ALWAYS_OFF";
    TimetableOverrideType["AUTO"] = "AUTO";
})(TimetableOverrideType || (TimetableOverrideType = {}));
export var TimetableOverrideTypeLabel;
(function (TimetableOverrideTypeLabel) {
    TimetableOverrideTypeLabel["ALWAYS_ON"] = "Always On";
    TimetableOverrideTypeLabel["ALWAYS_OFF"] = "Always Off";
    TimetableOverrideTypeLabel["AUTO"] = "On Schedule";
})(TimetableOverrideTypeLabel || (TimetableOverrideTypeLabel = {}));
export var TimetableReferenceType;
(function (TimetableReferenceType) {
    TimetableReferenceType["EQUIPMENT_OPERATING_HOURS"] = "EQUIPMENT_OPERATING_HOURS";
    TimetableReferenceType["SITE_OPERATING_HOURS"] = "SITE_OPERATING_HOURS";
    TimetableReferenceType["SCHEDULER"] = "SCHEDULER";
    TimetableReferenceType["LIGHT_SENSOR"] = "LIGHT_SENSOR";
    TimetableReferenceType["VENSTAR_HVAC_CONTROL"] = "VENSTAR_HVAC_CONTROL";
    TimetableReferenceType["HEATING"] = "HEATING";
    TimetableReferenceType["COOLING"] = "COOLING";
})(TimetableReferenceType || (TimetableReferenceType = {}));
export var TimetableReferenceSopType;
(function (TimetableReferenceSopType) {
    TimetableReferenceSopType["EQUIPMENT_OPERATING_HOURS"] = "EQUIPMENT_OPERATING_HOURS";
    TimetableReferenceSopType["SITE_OPERATING_HOURS"] = "SITE_OPERATING_HOURS";
})(TimetableReferenceSopType || (TimetableReferenceSopType = {}));
export var TimetableReferenceControlsType;
(function (TimetableReferenceControlsType) {
    TimetableReferenceControlsType["SCHEDULER"] = "SCHEDULER";
    TimetableReferenceControlsType["LIGHT_SENSOR"] = "LIGHT_SENSOR";
    TimetableReferenceControlsType["VENSTAR_HVAC_CONTROL"] = "VENSTAR_HVAC_CONTROL";
    TimetableReferenceControlsType["HEATING"] = "HEATING";
    TimetableReferenceControlsType["COOLING"] = "COOLING";
})(TimetableReferenceControlsType || (TimetableReferenceControlsType = {}));
export var TimetableReferenceTypeToLabel;
(function (TimetableReferenceTypeToLabel) {
    TimetableReferenceTypeToLabel["EQUIPMENT_OPERATING_HOURS"] = "Operating Hours (Equipment)";
    TimetableReferenceTypeToLabel["SITE_OPERATING_HOURS"] = "Occupied Hours (Site)";
    TimetableReferenceTypeToLabel["SCHEDULER"] = "Scheduler";
    TimetableReferenceTypeToLabel["LIGHT_SENSOR"] = "Light Sensor";
    TimetableReferenceTypeToLabel["VENSTAR_HVAC_CONTROL"] = "HVAC";
    TimetableReferenceTypeToLabel["HEATING"] = "Heating";
    TimetableReferenceTypeToLabel["COOLING"] = "Refrigeration";
})(TimetableReferenceTypeToLabel || (TimetableReferenceTypeToLabel = {}));
